// @flow
import * as React from 'react';
import { Formik, Form } from 'formik';
import type { FormikActions } from 'formik';
import * as Yup from 'yup';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

//  Components
import { Container, Row, Col } from 'reactstrap';
import Button from 'components/atoms/Button';
import { TextField, FormikField, PasswordField } from 'components/api';

// Utils
import { isObjEmpty } from 'utils/varValidation';

import './ChangePassword.scss';

const ns = 'change-password';

type Props = {
  close: () => void,
  changePassword: (oldPassword: string, newPassword: string) => Object,
  intl: IntlShape
};

type Values = {
  oldPassword: string,
  newPassword: string
};

const validationSchema = Yup.object().shape({
  oldPassword: Yup.string().required(),
  newPassword: Yup.string().required()
});

class ChangePassword extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    (this: any).onSubmit = this.onSubmit.bind(this);
  }

  initialValues = {
    oldPassword: '',
    newPassword: ''
  };

  async onSubmit(values: Values, actions: FormikActions<Values>) {
    const { oldPassword, newPassword } = values;
    const { setSubmitting, setStatus } = actions;
    const { close } = this.props;
    const { changePassword } = this.props;
    const data = await changePassword(oldPassword, newPassword);
    const success = data && data.success;
    setSubmitting(false);
    setStatus({ success });
    if (success) {
      close();
    }
  }

  render() {
    return (
      <Formik
        initialValues={this.initialValues}
        validationSchema={validationSchema}
        onSubmit={this.onSubmit}
        render={({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          dirty,
          status
        }) => {
          const disabled = !dirty || !isObjEmpty(errors);
          const { close, intl } = this.props;
          return (
            <Container className={ns}>
              <Row>
                <Col className={`${ns}__card d-flex flex-column`}>
                  <h1
                    className={`${ns}__title align-self-md-center mb-md-2 mb-lg-4 pt-lg-5`}
                  >
                    {intl.formatMessage({ id: 'c8.change.password.title' })}
                  </h1>
                  <Form onSubmit={handleSubmit}>
                    <FormikField
                      renderedComponent={TextField}
                      name="oldPassword"
                      placeholder={intl.formatMessage({
                        id: 'c8.change.password.old.password'
                      })}
                      type={'password'}
                      aria-label={intl.formatMessage({
                        id: 'c8.aria.change.password.old.password',
                        defaultMessage: 'Introduce old password'
                      })}
                    />
                    <FormikField
                      renderedComponent={PasswordField}
                      name="newPassword"
                      placeholder={intl.formatMessage({
                        id: 'c8.change.password.new.password'
                      })}
                      aria-label={intl.formatMessage({
                        id: 'c8.aria.change.password.new.password',
                        defaultMessage: 'Introduce new password'
                      })}
                    />
                    <div className={`d-flex flex-column`}>
                      <Button
                        className={`${ns}__change-password-button`}
                        disabled={disabled}
                        type="Submit"
                      >
                        <div className={`py-2`}>
                          {intl.formatMessage({
                            id: 'c8.change.password.change.password'
                          })}
                          {isSubmitting && (
                            <div className="ld ld-ring ld-spin-fast" />
                          )}
                        </div>
                      </Button>
                      <Button
                        buttonTheme="link"
                        onClick={() => {
                          close();
                        }}
                      >
                        {intl.formatMessage({ id: 'c8.common.cancel' })}
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          );
        }}
      />
    );
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/pages/User/Profile/components/ChangePassword/ChangePassword.js